<template>
  <div class="box">
    <table class="table" cellspacing="0">

      <thead>
        <tr>
          <th>Document</th>
          <th>Exclude cancellations?</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody>

        <tr v-if="group.tour.tour_type == 'air'">
          <td>Flight manifest (Outbound)</td>
          <td><input type="checkbox" v-model="cancellations.flightDepartures"></td>
          <td><button @click="download('flight-outbound', cancellations.flightDepartures)">Download</button></td>
          <td><button @click="downloadPdf('flight-outbound', cancellations.flightDepartures)">Download Pdf</button></td>
          <td><button @click="print('flight-outbound', cancellations.flightDepartures)">Print</button></td>
        </tr>

        <tr v-if="group.tour.tour_type == 'air'">
          <td>Flight manifest (Return)</td>
          <td><input type="checkbox" v-model="cancellations.flightArrivals"></td>
          <td><button @click="download('flight-return', cancellations.flightArrivals)">Download</button></td>
          <td><button @click="downloadPdf('flight-return', cancellations.flightArrivals)">Download Pdf</button></td>
          <td><button @click="print('flight-return', cancellations.flightArrivals)">Print</button></td>
        </tr>

        <tr>
          <td>Rooming list</td>
          <td><input type="checkbox" v-model="cancellations.rooming"></td>
          <td><button @click="download('rooming', cancellations.rooming)">Download</button></td>
          <td><button @click="download('rooming', cancellations.rooming)">Print</button></td>
        </tr>

      </tbody>
    </table>
    <!-- Customer notes Modal -->
    <div class="modal-lg" v-if="showDocumentNameModal == true" style="max-width: 35%;min-height: auto;">
      <button type="button" class="icon icon--unlink" v-on:click="showDocumentNameModal = false">Close</button>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="" class="form-label">Document Name</label>
            <input type="text" class="form-control" placeholder="Document Name" v-model="documentName">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <button class="button mt-1" @click="GenerateDocument"><span> Generate Document </span></button>
        </div>
      </div>
    </div>
    <div class="modal__bg" v-if="showDocumentNameModal == true"></div>
  </div>
</template>

<script>
import printJS from 'print-js'
import {mapGetters} from 'vuex'
import moment from 'moment';

export default {
  name: 'TourGroupDocuments',
  props : {
    group: Object
  },
  data () {
    return {
      showDocumentNameModal:false,
      selectedDocuments: null,
      cancellations: {
        flightArrivals: false,
        flightDepartures: false,
        rooming: false,
      },
      documentGenerateUrI:null,
      document: null,
      documentName:null,
      excludeCancellations: false,
      documentExtension: null,
      
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
  },
  methods: {
    download(document, excludeCancellations) {
        this.documentGenerateUrI = this.$api + 'tours/groups/' + this.group.id + '/documents';
        this.document = document
        this.excludeCancellations = excludeCancellations
        this.documentExtension = "xlsx"
        this.setDocumentName()
        this.showDocumentNameModal = true
    },
    downloadPdf(document, excludeCancellations) {
      this.documentGenerateUrI = this.$api + 'tours/groups/' + this.group.id + '/documents/pdf';
      this.document = document
      this.excludeCancellations = excludeCancellations
      this.documentExtension = "pdf"
      this.setDocumentName()
      this.showDocumentNameModal = true
    },
    print(document, excludeCancellations) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/groups/' + this.group.id + '/documents/pdf', {
        method: 'POST',
        body: JSON.stringify({
          document: document,
          excludeCancellations: excludeCancellations
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success == true) printJS(this.$api + 'tours/groups/document/mistral-tour-' + this.group.id + '-' + document + '.pdf/download');
        this.$store.dispatch('setLoadStatus')
      }).catch((error) => {
        this.$store.dispatch('setLoadStatus')
        console.log(error)
      })
    },
    setDocumentName() {
      let dateTime = moment(this.group.start_date).format('DD MMMM YYYY')
      let daysToAdd = (this.group.duration) ? Number(this.group.duration) - 1 : 7;
      console.log(daysToAdd);
      
      let selectedDocumentType = null;
      switch (this.document) {
        case 'flight-outbound': selectedDocumentType = "Flight Arrivals"; break;
        case 'flight-return': selectedDocumentType = `Flight Departures (${moment(this.group.start_date).add(daysToAdd,'days').format('DD MMM YYYY')})`; break;
        case 'rooming': selectedDocumentType = `Rooming List`; break;
        default: break;
      }
      this.documentName = `${dateTime} - ${this.group.tour.reference} - ${selectedDocumentType}`
    },
    GenerateDocument() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.documentGenerateUrI, {
        method: 'POST',
        body: JSON.stringify({
          document: this.document,
          excludeCancellations: this.excludeCancellations
        }),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
        }
      })
      .then((response) => {
        if(response.status === 200) {
          this.$store.dispatch('setLoadStatus')
          response.blob().then(response => {
              const _url = window.URL.createObjectURL(response)
              const link = document.createElement('a')
              link.href = _url
              link.setAttribute('download', `${this.documentName}.${this.documentExtension}`)
              document.body.appendChild(link)
              link.click();
          })
        } else {
            this.$store.dispatch('setLoadStatus')
            Promise.race([res.json()])
            .then(response => {
            if(response.message) {
                this.$notify({
                type: 'error',
                title: response.message
                });
            } else {
                this.$notify({
                type: 'error',
                title: response.error
                });
            }
            })
        }
      }).catch((error) => {
        this.$store.dispatch('setLoadStatus')
        console.log(error)
      })
    }
  }
}
</script>
